<template>
	<div v-if="show" class="majorel-im-dialog-mask animated fadeIn">
		<el-container class="majorel-im-dialog-box" v-outside="closeBox">
			<el-header class="no-padding header" height="50px">
				<p>发送文件</p>
				<p class="tools">
					<i class="el-icon-close" @click="closeBox" />
				</p>
			</el-header>

			<el-main class="no-padding mian">
				<template v-if="!uploadStatus">
					<div class="main-file">
						<div class="ext">{{ ext }}</div>
						<div class="file-box">
							<p class="info">
								<span class="name">{{ fileName }}</span>
								<span class="size">({{ fileSize }})</span>
							</p>
							<p class="notice">文件类型</p>
						</div>
					</div>
				</template>
				<template v-else>
					<file-message :file="source.attachment"></file-message>
				</template>
			</el-main>

			<el-footer class="footer" height="50px">
				<el-button class="btn" type="primary" size="medium" :loading="loading" @click="uploadFilee">立即发送
				</el-button>
			</el-footer>
		</el-container>
	</div>
</template>
<script>
	import {formateSize} from '@/utils/functions'
	export default {
		name: 'EditorFileView',
		model: {
			prop: 'show',
			event: 'close',
		},
		props:{
			show:{
				default:false,
				type:Boolean
			},
			source:{
				default:''
			},
			uploadStatus:{
				default:false,
				type:Boolean
			}
		},
		watch: {
			source(file) {
				if(this.uploadStatus)return;
				this.loadFile(file)
			},
		},
		data() {
			return {
				ext: '',
				fileSize: '',
				fileName: '',
				loading: false,
			}
		},
		methods: {
			closeBox() {
				if (this.loading) {
					return false
				}

				this.$emit('close', false)
			},
			loadFile(file) {
				let reader = new FileReader();
				this.fileSize = formateSize(file.size);
				this.fileName = file.name;
				this.ext = file.name.substring(file.name.lastIndexOf(".")+1).toUpperCase();
				reader.readAsDataURL(file);
			},

			// 确认按钮事件
			uploadFilee() {
				this.loading = true
				this.$emit('confirm')
			},
		},
	}
</script>
<style lang="scss" scoped>
	.majorel-im-dialog-box {
		width: 500px;
		max-width: 500px;
		height: 450px;
		background-color: #fff;
		.mian {
			justify-content: center;
			display: flex;
			flex-direction: row;
			align-items: center;
			.main-file {
				height: 85px;
				width: 250px;
				box-shadow: 0 0 5px 0px #e8e4e4;
				display: flex;
				flex-direction: row;
				align-items: center;
				padding: 10px;
			}
			.ext {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 45px;
				height: 45px;
				flex-shrink: 0;
				color: #ffffff;
				background: #49a4ff;
				border-radius: 5px;
				font-size: 12px;
			}
			.file-box {
				flex: 1 1;
				height: 45px;
				margin-left: 10px;
				overflow: hidden;
			
				.info {
					display: flex;
					justify-content: space-between;
					align-items: center;
					overflow: hidden;
					height: 24px;
					color: rgb(76, 76, 76);
					font-size: 14px;
			
					.name {
						flex: 1 auto;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}
			
					.size {
						font-size: 12px;
						color: #cac6c6;
					}
				}
			
				.notice {
					height: 25px;
					line-height: 25px;
					font-size: 12px;
					color: #929191;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}
		}

		.footer {
			height: 50px;
			background: rgba(247, 245, 245, 0.66);
			text-align: center;
			line-height: 50px;

			.btn {
				width: 150px;
				border-radius: 2px;
			}
		}
	}
</style>
